import React from 'react';
import groupDiscussion from "../../../assets/images/groupDiscussion.png";

const GdStartPresenter = ({ onPress, nominateType }) => {
  console.log('nominateType::::', nominateType);
  let nominator = '';
  if (nominateType === 'GROUP_MEMBERS') {
    nominator = 'Your group members have';
  } else if (nominateType === 'GROUP_LEADER') {
    nominator = 'Your group leader has';
  }

  return (
    <div className="flex flex-1 flex-col justify-center items-center h-full">
      <img
        src={groupDiscussion}
        alt="Group Discussion"
        className="object-contain max-w-full max-h-full mb-4"
      />
      <span className="text-base text-gray-800 text-center mb-4">
        {`${nominator} nominated you as Presenter\n\nStart your presentation prep NOW`}
      </span>
      <button
        className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
        onClick={onPress}
      >
        OK
      </button>
    </div>
  );
};

export default GdStartPresenter;